import { Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import getTableCompanions from './getTableCompanions';

declare global {
	interface CommandType {
		setTableCompanions: () => Promise<Result>
	}
}

Command.register('setTableCompanions', Preconditions.ensure(Permission.SaleLocation_Change), async (): Promise<Result> => {

	const ticket = SalesStore.getTicket();

	const result = await getTableCompanions(ticket, 9999);
	if (!result.ok)
		return Result.error();

	await SalesStore.setTableCompanions(result.value);
	return Result.ok();
});
